export default __webpack_public_path__ + "static/media/Trend9.14bd9898.svg";